export default __webpack_public_path__ + "static/media/work-6.5c294414.jpg";